import { t } from 'i18next';
import React from 'react';
import { Helmet } from 'react-helmet';

export default function PageNotFound() {
  return (
    <>
      <Helmet>
        <title>{t('pageNotFound')}</title>
      </Helmet>
      <div className="min-h-[calc(100vh-7rem)] w-full flex items-center justify-center">
        <h2 className="font-bold">{t('pageNotFound')}</h2>
      </div>
    </>
  );
}
